/* Copyright (C) 2018 TeselaGen Biotechnology, Inc. */
import Color from "color";
export default (function (c) {
  return Color(c).isLight() ? "#000000" : "#FFFFFF";
});